import {
  M,
  TYPE,
  marketingBtnPrimarySx,
  marketingBtnSecondaryLightSx,
} from "../../constants/marketingTokens";
import { PANEL } from "./panelTokens";

export const panelFormPageSx = {
  width: "100%",
  maxWidth: 1400,
  mx: "auto",
  display: "flex",
  flexDirection: "column",
  gap: 1.5,
  pb: 2,
  minHeight: 0,
};

export const panelFormCardSx = {
  elevation: 0,
  width: "100%",
  maxWidth: 760,
  bgcolor: PANEL.surface,
  borderRadius: { xs: PANEL.radius.card, sm: "20px" },
  border: `1px solid ${PANEL.border}`,
  boxShadow: PANEL.shadow.elevated,
  overflow: "hidden",
};

export const panelFormCardWideSx = {
  ...panelFormCardSx,
  maxWidth: "none",
  display: "flex",
  flexDirection: "column",
  minHeight: 0,
};

export const panelFormCardAccentBarSx = {
  height: 6,
  background: `linear-gradient(90deg, ${PANEL.accent.main}, var(--panel-gradient-end))`,
};

/** Call-site sx array'inin sonuna konur — nested `sx` rengi ezemesin */
export const panelFieldColorLockSx = {
  "& .MuiInputBase-input": {
    color: `${PANEL.text.primary} !important`,
    WebkitTextFillColor: `${PANEL.text.primary} !important`,
    caretColor: PANEL.text.primary,
    "&::placeholder": {
      color: `${PANEL.text.muted} !important`,
      opacity: 1,
      WebkitTextFillColor: `${PANEL.text.muted} !important`,
    },
  },
  "& .MuiOutlinedInput-input": {
    color: `${PANEL.text.primary} !important`,
    WebkitTextFillColor: `${PANEL.text.primary} !important`,
  },
  "& .MuiSelect-select": {
    color: `${PANEL.text.primary} !important`,
    WebkitTextFillColor: `${PANEL.text.primary} !important`,
  },
  "& .MuiSelect-icon": {
    color: PANEL.text.muted,
  },
  "& .MuiInputLabel-root:not(.Mui-error)": {
    color: PANEL.text.muted,
  },
  "& .MuiInputLabel-root.Mui-focused:not(.Mui-error)": {
    color: PANEL.accent.text,
  },
  "& .MuiInputLabel-root.Mui-error": {
    color: `${PANEL.danger.main} !important`,
  },
};

export const panelFormFieldSx = {
  "& .MuiOutlinedInput-root": {
    fontFamily: "'Inter', sans-serif",
    borderRadius: PANEL.radius.input,
    backgroundColor: PANEL.surface,
    color: PANEL.text.primary,
    "&:not(.Mui-error) fieldset": { borderColor: PANEL.border },
    "&:not(.Mui-error):hover fieldset": { borderColor: PANEL.fill.hover },
    "&:not(.Mui-error).Mui-focused fieldset": { borderColor: PANEL.accent.focus },
    "&:not(.Mui-error).Mui-focused": {
      boxShadow: `0 0 0 3px ${PANEL.accent.focusRing}`,
    },
    "&.Mui-error fieldset": {
      borderColor: `${PANEL.danger.main} !important`,
      borderWidth: "1.5px !important",
    },
    "&.Mui-error.Mui-focused": {
      boxShadow: "0 0 0 3px rgba(239, 68, 68, 0.25) !important",
    },
  },
  "& .MuiOutlinedInput-input": {
    color: `${PANEL.text.primary} !important`,
    WebkitTextFillColor: PANEL.text.primary,
    "&::placeholder": {
      color: PANEL.text.muted,
      opacity: 1,
    },
  },
  "& .MuiSelect-select": {
    color: `${PANEL.text.primary} !important`,
  },
  "& .MuiSelect-icon": {
    color: PANEL.text.muted,
  },
  "& .MuiInputAdornment-root": {
    color: PANEL.text.muted,
  },
  "& .MuiInputLabel-root:not(.Mui-error)": {
    color: PANEL.text.muted,
  },
  "& .MuiInputLabel-root.Mui-focused:not(.Mui-error)": {
    color: PANEL.accent.text,
  },
  "& .MuiInputLabel-root.MuiInputLabel-shrink:not(.Mui-focused):not(.Mui-error)": {
    color: PANEL.text.muted,
  },
  "& .MuiInputLabel-root.Mui-error": {
    color: `${PANEL.danger.main} !important`,
  },
  "& .MuiFormHelperText-root:not(.Mui-error)": {
    color: PANEL.text.muted,
    marginLeft: 0,
  },
  "& .MuiFormHelperText-root.Mui-error": {
    color: `${PANEL.danger.main} !important`,
    fontWeight: 600,
    fontSize: "0.75rem",
    marginLeft: 0,
    marginTop: "4px",
    display: "block",
  },
};

export const panelFormFieldLabelSx = {
  fontFamily: "'Inter', sans-serif",
  fontSize: "0.8125rem",
  lineHeight: 1.45,
  color: PANEL.text.primary,
  fontWeight: 600,
  mb: 1,
  display: "block",
};

export const panelFormSectionTitleSx = {
  fontFamily: "'Inter', sans-serif",
  fontSize: "1.05rem",
  fontWeight: 700,
  lineHeight: 1.3,
  color: PANEL.text.title,
  mb: 2,
};

export const panelFormSectionPanelSx = {
  bgcolor: PANEL.fill.muted,
  borderRadius: PANEL.radius.cardSm,
  border: `1px solid ${PANEL.border}`,
  p: { xs: 2, md: 2.5 },
};

export const panelFormSectionPanelGrowSx = {
  ...panelFormSectionPanelSx,
  flex: 1,
  display: "flex",
  flexDirection: "column",
  minHeight: 0,
  overflow: "hidden",
};

/** İzin matrisi — flex içinde dikey kaydırma */
export const panelFormMatrixScrollSx = {
  flex: 1,
  minHeight: 0,
  overflow: "auto",
  width: "100%",
};

export const panelFormTypeBadgeSx = {
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  p: 2,
  borderRadius: PANEL.radius.cardMd,
  border: `1px solid ${PANEL.border}`,
  bgcolor: PANEL.fill.muted,
};

export const panelFormTypeBadgeCompactSx = {
  display: "flex",
  alignItems: "center",
  gap: 1.25,
  p: 1.5,
  height: "100%",
  minHeight: 56,
  borderRadius: PANEL.radius.cardMd,
  border: `1px solid ${PANEL.border}`,
  bgcolor: PANEL.surface,
};

/** Paylaşılan dosya seçici — mevcut dosya kartı */
export const panelSharedFilePickCardSx = {
  p: 2,
  bgcolor: PANEL.surface,
  borderRadius: PANEL.radius.cardMd,
  border: `1px solid ${PANEL.border}`,
  cursor: "pointer",
  transition: "box-shadow 0.2s ease, border-color 0.2s ease, transform 0.2s ease",
  boxShadow: PANEL.shadow.card,
  "&:hover": {
    borderColor: PANEL.accent.softBorder,
    transform: "translateY(-2px)",
    boxShadow: PANEL.shadow.cardHover,
  },
};

export const panelSharedFileAddButtonSx = {
  color: PANEL.accent.text,
  bgcolor: PANEL.accent.soft,
  border: `1px solid ${PANEL.accent.softBorder22}`,
  "&:hover": {
    bgcolor: PANEL.accent.soft18,
  },
};

/** Seçili dosya — accordion */
export const panelSharedFileAccordionSx = {
  mb: 1.5,
  bgcolor: PANEL.surface,
  borderRadius: `${PANEL.radius.cardMd} !important`,
  border: `1px solid ${PANEL.border}`,
  boxShadow: PANEL.shadow.card,
  "&:before": { display: "none" },
  overflow: "hidden",
};

/** Dosya / form / hasta izin alt panelleri */
export const panelSharedFilePermissionPanelSx = {
  p: 2,
  mb: 1.5,
  bgcolor: PANEL.fill.muted,
  borderRadius: PANEL.radius.input,
  border: `1px solid ${PANEL.border}`,
};

export const panelSharedFileCheckboxSx = {
  color: PANEL.text.label,
  "&.Mui-checked": {
    color: PANEL.accent.main,
  },
};

export const panelSharedFileRemoveButtonSx = {
  color: PANEL.danger.text,
  "&:hover": {
    bgcolor: PANEL.danger.soft,
  },
};

/** @deprecated tenant* — geriye uyumluluk alias'ları */
export const tenantFormPageSx = panelFormPageSx;
export const tenantFormCardSx = panelFormCardSx;
export const tenantFormCardWideSx = panelFormCardWideSx;
export const tenantFormCardAccentBarSx = panelFormCardAccentBarSx;
export const tenantFormFieldSx = panelFormFieldSx;
export const tenantFormFieldLabelSx = panelFormFieldLabelSx;
export const tenantFormSectionTitleSx = panelFormSectionTitleSx;
export const tenantFormSectionPanelSx = panelFormSectionPanelSx;
export const tenantFormSectionPanelGrowSx = panelFormSectionPanelGrowSx;
export const tenantFormMatrixScrollSx = panelFormMatrixScrollSx;
export const tenantFormTypeBadgeSx = panelFormTypeBadgeSx;
export const tenantFormTypeBadgeCompactSx = panelFormTypeBadgeCompactSx;

/** Marketing re-export — panel stilleri bunları kullanmaz */
export { M, TYPE, marketingBtnPrimarySx, marketingBtnSecondaryLightSx };
